export default {
  period_types: [],
  period: {},
  periods: [],
}
